import { 
	createSlice,
	createSelector,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'

import {
	envAwarePost,
	dateToAPIStandard
} from '../../util/util'

import {
	getCurrentDate,
} from '../../util/datetime'

export const getAllEventsInRange = createAsyncThunk(
	'gymCalendar/getAllEventsInRange',
	async (payload,{getState}) => {
		const {start,limit} = getState().gymCalendar.range
		return await envAwarePost(
			'api/scheduler',
			{action:'getAllEventsInRange',start_date:start,limit,skip_legacy_logic:1}
		)
	}
)

export const createCalendarEvent = createAsyncThunk(
	"createCalendarEvent",
	async (payload,{dispatch}) => (
		envAwarePost("api/scheduler/", payload)
		.then(async(res)=>{
			await dispatch(getAllEventsInRange())
			return res
		})
	)
)

export const editCalendarEvent = createAsyncThunk(
	"editCalendarEvent",
	async (payload,{dispatch}) => (
		envAwarePost("api/scheduler/api.php", payload)
		.then(async (res)=>{
			await dispatch(getAllEventsInRange())
			return res
		})
	)
)

export const deleteCalendarEvent = createAsyncThunk(
	"deleteCalendarEvent",
	async (payload) => await envAwarePost(
		'api/scheduler/',
		{action:'deleteCalendarEvent',...payload}
	)
)

const adapter = createEntityAdapter()

const slice = createSlice({
	name: 'gymCalendar',
	initialState : adapter.getInitialState({
		viewer:{
			show:false,
			id:null
		},
		editor:{
			show:false,
			id:null,
			date:null,
			editSeries:false
		},
		creator:{
			show:false,
			date:null,
			time:{
				start:{},
				end:{}
			}
		},
		range:{
			start:getCurrentDate(),
			limit:'90'
		},
		status:'init',
	}),
	reducers : {
		setViewer:(state,action)=>{
			state.viewer.show = action.payload.show
			state.viewer.id = action.payload.id
		},
		setEditor:(state,action)=>{
			state.editor.show = action.payload.show
			state.editor.id = action.payload.id
			state.editor.editSeries = action.payload.editSeries
		},
		setCreator:(state,action)=>{
			state.creator.show = action.payload.show
			state.creator.date = action.payload.date
			state.creator.time.start = action.payload.time.start
			state.creator.time.end = action.payload.time.end
		},
		setRange:(state,action)=>{
			state.range.start = action.payload
		}
	},
	extraReducers : (builder)=>{
		builder
			.addCase(getAllEventsInRange.pending,(state,action)=>{
				state.status = 'pending'
			})
			.addCase(getAllEventsInRange.fulfilled,(state,action)=>{
				state.status = 'idle'
				const flattened = []
				action.payload.data.forEach(dateGroup=>{
					dateGroup.events.forEach(event=>{
						//add a unique id for each occurence since calendar_id
						//is shared for these
						event.id = `${event.calendar_id}-${event.occurrence_date}`
						flattened.push(event)
					})
				})
				adapter.setAll(state,flattened)
			})
			.addCase(deleteCalendarEvent.pending,(state,action)=>{
				const deleteSeries = action.meta.arg.edit_series
				const deleteId = (
					deleteSeries
					? action.meta.arg.event_id
					: action.meta.arg.occurrence_id
				)
				const deleteIds = state.ids.filter(id=>{
					const event = state.entities[id]
					return (
						deleteSeries
						? (
							parseInt(event.calendar_id) === parseInt(deleteId)
							||
							parseInt(event.event_pid) === parseInt(deleteId)
						)
						: id === deleteId

					)
				})
				adapter.removeMany(state,deleteIds)
			})
	}
})

export const {
	setRange,
	setViewer,
	setCreator,
	setEditor
} = slice.actions

export const selectors = adapter.getSelectors(
	state=>state.gymCalendar
)


export default slice.reducer